import parseDate from "../../../../controllers/parseDate";
import CardForItem from "../../../customUiForCs/CardForItem";

export default function AssignmentHistoryCard({ data }) {
  let title = `${parseDate(data.startDate)} - ${parseDate(data.endDate)}`;
  let image = null;
  let line1 = [
    {
      text: `Est-elle justifiée : ${data.isJustified ? "Oui" : "Non"} | ${data.note}`,
    },
  ];
  let line2 = null;

  if (data.profile) {
    title = `${data.profile.lastName} ${data.profile.firstName}`;
    image = data.profile.profileImage;

    line1 = [
      { text: `${parseDate(data.startDate)} - ${parseDate(data.endDate)}` },
    ];

    line2 = [
      {
        text: `Est-elle justifiée : ${data.isJustified ? "Oui" : "Non"} | ${data.note}`,
      },
    ];
  }

  let tertiaryBubbleLine = null;
  if (data.site) {
    if (!tertiaryBubbleLine) tertiaryBubbleLine = [];
    tertiaryBubbleLine.push({ text: `Site: ${data.site.placeName}` });
  }

  if (data.zone) {
    if (!tertiaryBubbleLine) tertiaryBubbleLine = [];
    tertiaryBubbleLine.push({ text: `Zone: ${data.zone.name}` });
  }

  return (
    <CardForItem
      itemType={"ABSENCE"}
      // image={image}
      title={title}
      line1={line1}
      line2={line2}
      tertiaryBubbleLine={tertiaryBubbleLine}
      editPath="edit-absence"
      absolutePath={`/employee/${data.userID}`}
      itemID={data._id}
    />
  );
}
